import {useEffect} from "react";
import {useMap, useMapLayerProvider} from "base/component/geo";
import {useList} from "base/provider";

const mapStyle = {
    width: "100%",
    height: "650px",
};

const EntityListMap = ({
    layer: layerHook,
    service,
    selectedElement = null,
    onSelectElement = null,
}) => {
    const [{setItems, items}] = useMapLayerProvider(service);
    const {filter, setSize} = useList();

    const {mapRef, createMap} = useMap();

    const {
        layerRef,
        createLayer,
        updateLayer,
        clearLayer,
        changeSelectedElement,
    } = layerHook(onSelectElement);

    useEffect(() => {
        const map = createMap();
        createLayer(map);

        return () => {
            if (map._loaded) {
                map.remove();
            }
        };
    }, []);

    useEffect(() => {
        service(filter).then(result => {
            setItems(result);
            setSize(result.features.length);
        });
    }, [filter]);

    useEffect(() => {
        clearLayer();
        updateLayer(items, true);
    }, [items]);

    useEffect(() => {
        if (changeSelectedElement) {
            changeSelectedElement(selectedElement);
        }
    }, [selectedElement]);

    return <div id="map" style={mapStyle} ref={mapRef} />;
};

export default EntityListMap;
